/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Subscription_NoInputs */

const en_settings_billing_subscription_no = /** @type {(inputs: Settings_Billing_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No.`)
};

const zh_settings_billing_subscription_no = /** @type {(inputs: Settings_Billing_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅号`)
};

/**
* | output |
* | --- |
* | "No." |
*
* @param {Settings_Billing_Subscription_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription_no = /** @type {((inputs?: Settings_Billing_Subscription_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Subscription_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_subscription_no(inputs)
	return zh_settings_billing_subscription_no(inputs)
});
export { settings_billing_subscription_no as "settings.billing.subscription_no" }